/* eslint-disable */

// inject styles
require('./dimelo.css');

const waitForElementToBeAdded = (cssSelector, cb) => {
    const interval = setInterval(() => {
        const element = document.querySelector(cssSelector);

        if (element) {
            clearInterval(interval);

            if (typeof cb === 'function') {
                cb(element);
            }
        }
    }, 100);
};

function isScriptAlreadyIncluded(src){
    const getChatScript = new RegExp("^" + src);
    const scripts = document.getElementsByTagName("script");
    
    for (let row of scripts) {
        if(row.getAttribute('src') && getChatScript.exec(row.getAttribute('src'))) return true;
    }
    return false;
};

function initialize(cfg) {
    setTimeout(() => {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                const _chatq = window._chatq || [];
                _chatq.push(["_setSignedIdentity", this.responseText]);
                window._chatq = _chatq;
                if (cfg?.enabled) {
                    const script = document.createElement('script');
                    script.src = `${cfg.options.url}`;
                    document.getElementsByTagName('head')[0].appendChild(script);
            
                    const interval = setInterval(() => {
                        if (isScriptAlreadyIncluded(`${cfg.options.chat_script}`)) {
                            clearInterval(interval);
                            setTimeout(() => {
                                console.log('Chat included');
                                _chatq.push(['_onEvent', 'message_sent', function () {
                                    const xhttp = new XMLHttpRequest();
                                    xhttp.onreadystatechange = function() {
                                        if (this.readyState == 4 && this.status == 200) {
                                            const _chatq = window._chatq || [];
                                            _chatq.push(["_setSignedIdentity", this.responseText]);
                                            window._chatq = _chatq;
                                        }
                                    };
                                    const auth_url = cfg.options.auth_url;
                                    xhttp.open("GET", auth_url, true);
                                    xhttp.withCredentials = true;
                                    xhttp.send();
                                }]);

                                let chat_was_closed = null;
                                _chatq.push(['_onEvent', 'chat_closed', function () {
                                    document.querySelector(".dimelo-chat-bubble.dimelo-chat-round-button").style.display = "none";
                                    chat_was_closed = true;
                                }]);
                                _chatq.push(['_onEvent', 'chat_shown', function () {
                                    if (chat_was_closed) {
                                    document.querySelector(".dimelo-chat-bubble.dimelo-chat-round-button").style.display = "";
                                    }
                                }]);
                                window._chatq = _chatq;
                            }, 500);
                        }
                    }, 100);
                }
            }
        };
        const auth_url = cfg.options.auth_url;
        xhttp.open("GET", auth_url, true);
        xhttp.withCredentials = true;
        xhttp.send();    
    }, 1000);
};

window.__va__(app => {

    // [1] Load dimelo by url from options.
    const [cfg] = app.config.files.filter(file => file.name === 'dimelo' && file.type === 'script');

    initialize(cfg);

    async function getAgentStatus(store) {
        const catId = store.chat.liveChatTriggers.catid ? store.chat.liveChatTriggers.catid : cfg.options.cat;
        store.chat.liveChatTriggers.catid = '';
        try {
            const response = await fetch(`${cfg.options.agent_url}?cat=${catId}`);
            let agentStatusResponse = await response.json();
            if (agentStatusResponse.is_agent_available) {
                let curTime = new Date(new Date().getTime() + (new Date().getTimezoneOffset() * 60000) + (3600000 * 8));
                curTime = parseInt(curTime.getHours() + "" + ("0" + curTime.getMinutes()).slice(-2) + "" + ("0" + curTime.getSeconds()).slice(-2));
                return (curTime < cfg.options.startTime || curTime >= cfg.options.endTime)? false : true;
            }
        } catch (error) {
            return false;
        }
    }

    // [4] Trigger the live chat from VA messages.
    function handleStart() {
        app.emit('liveChat.start');
    }

    /**
     * FUNCTIONS
     */

    const handleOffline = (store, type) => {
        if (store.chat.liveChatTag.offline !== ''){
            app.emit('message.htmlScroll', {
                content: store.chat.liveChatTag.offline,
                i18n: {}
            });
            store.chat.liveChatTag.offline = '';
        } else {
            if (type === 'TD') {
                app.emit('message.htmlScroll', {
                    content: 'liveChatUnableAssistTD',
                    i18n: {}
                });
            } else {
                app.emit('message.htmlScroll', {
                    content: 'liveChatUnableAssist',
                    i18n: {}
                });
            }
        }
    }

    const handleOnline = (triggerNodeId, store, type) => {
        if (store.chat.liveChatTag.online !== ''){
            app.emit('message.htmlScroll', {
                message: store.chat.liveChatTag.online,
                content: 'chatWithUsButton',
                i18n: { triggerNodeId }
            });
            store.chat.liveChatTag.online = '';
        } else {
            if (type === 'TD') {
                _chatq.push(["_fillCustomVariable", "custom_thumbs_down", true]);
                app.emit('message.htmlScroll', {
                    content: 'liveChatAbleAssistTD',
                    i18n: {
                        triggerNodeId
                    }
                });
            } else {
                app.emit('message.htmlScroll', {
                    content: 'liveChatAbleAssist',
                    i18n: {
                        triggerNodeId
                    }
                });
            }
        }
    }

    const removePreviousNode = triggerNodeId => {
        // Remove the previous nodeId
        const prevTriggerNodeId = document.getElementById(triggerNodeId);
        if (prevTriggerNodeId) {
            prevTriggerNodeId.removeAttribute('id');
            prevTriggerNodeId.removeEventListener('click', handleStart);
            prevTriggerNodeId.style.opacity = "0.5";
        }
    }

    const addNewNode = triggerNodeId => {
        waitForElementToBeAdded(`#${triggerNodeId}`, () => {
            const triggerNode = document.getElementById(triggerNodeId);

            if (triggerNode !== null) {
                triggerNode.addEventListener('click', handleStart);
            }
        });
    }

    const checkAgentAvailability = (type) => {
        let isChecked = false;
       
        app.emit('getStore');
        app.on('store', (_, store) => {
            if (isChecked) {
                return;
            }
            isChecked = true; 
            const triggerNodeId = 'dimelochat-trigger';
            removePreviousNode(triggerNodeId);
            addNewNode (triggerNodeId);

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const app = urlParams.get('r');

            if (app === cfg.options.persistent_chat_param) handleOnline(triggerNodeId, store, type);
            else {
                getAgentStatus(store).then(agentStatus => {
                    if (agentStatus) {
                        handleOnline(triggerNodeId, store, type);
                    } else {
                        handleOffline(store, type);
                    }
                })
                .catch(() => {
                    handleOffline(store, type);
                });
            }
        });
    };

    // Check if the agent is available or unavailable
    app.on('liveChat.suggest', () => {
        checkAgentAvailability('');
    });

    app.on('liveChat.suggestThumbsDown', () => {
        checkAgentAvailability('TD');
    });

    const getChatHistory = (store, count) => {
        const allMessages = store.chat.messages;

        // Take only the last `count` user messages
        const lastUserMessages = allMessages.filter(item => item.type === 1).slice(-count);
        const questions = [];
        lastUserMessages.forEach(mesItem => {
            questions.push(mesItem.content);
        });

        // All questions turn to the one line
        if (questions.length > 0) {
            let questionsContent = '';
            for (let i = 0; i < questions.length; i++) {
                questionsContent = questionsContent + "" + (i+1) + ". " + questions[i] + "\n";
             }
            return questionsContent;
        }

        return null;
    };

    let isPushed = false;

    // Find elements of an array which satisfy a filter function
    const grep = function(items, callback) {
        const filtered = [];
        let i = 0;
        for (i; i < items.length; i++) {
            const item = items[i];
            const cond = callback(item);
            if (cond) {
                filtered.push(item);
            }
        }
        return filtered;
    };

    const openDimeloChat = function(jwt) {
        _chatq.push(["_setSignedIdentity", jwt]);
    };

    const logDimeloChat = function(jwt,qnsasked,store) {
        const http = new XMLHttpRequest();
        const url = cfg.options.log_url;
        const params = 'session_id=' + store.app.sessionId + '&service_id=' + jwt + '&chathistory=' + qnsasked + '';
        http.open('POST', url, true);

        //Send the proper header information along with the request
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.withCredentials = true;
        http.send(params);
    };

    const checkOneLoginAuth = function(store) {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {

            if (this.readyState == 4 && this.status == 200) {
            openDimeloChat(this.responseText);
            const qnsasked = cfg.options.chatHistory.enabled? getChatHistory(store, cfg.options.chatHistory.lastMessagesCount) : '';
            _chatq.push(["_addMessage", { body: cfg.options.liveChatQuesTitle, engage: true }])
            const intervalEngaged = setInterval(() => {
                if (document.getElementsByClassName('dimelo-chat-message-identity-screenname').length > 0) {
                    clearInterval(intervalEngaged);
                    _chatq.push(["_addMessage", { body: qnsasked }])
                    _chatq.push(["_addMessage", { body: cfg.options.liveChatIntro, agent: true }])
                    logDimeloChat(this.responseText,qnsasked,store);
                }
            }, 100);
            }
        };

        const auth_url = cfg.options.auth_url;
        xhttp.open("GET", auth_url, true);
        xhttp.withCredentials = true;
        xhttp.send();
    };

    const checkOneLoginAuthWithoutQueryWithoutLog = function() {
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
            openDimeloChat(this.responseText);
            }
        };
        const auth_url = cfg.options.auth_url;
        xhttp.open("GET", auth_url, true);
        xhttp.withCredentials = true;
        xhttp.send();
    };

    const handleChatEvent = (store, trigger_id) => {
        _chatq.push(['_onEvent', 'chat_shown', function (trigger) {
            if (trigger.trigger_continuation)
            {
                //to resend setSignedIdentity on refresh
                checkOneLoginAuthWithoutQueryWithoutLog();
                return; // Avoids executing on each page refresh
            }
            checkOneLoginAuth(store);
        }]);
        isPushed = true;
    } 

    const startChat = () => {

        let isChecked = false;
        app.emit('getStore');
        app.on('store', (_, store) => {
            if (!isChecked && window.screen.width > 1200) {
                store.chatWindow.minimize();
            }

            if (isChecked) {
                return;
            }

            isChecked = true;

            if (isChecked) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const app = urlParams.get('r');

                let trigger_id = store.chat.liveChatTriggers.triggerid ? store.chat.liveChatTriggers.triggerid : cfg.options.key;
                    store.chat.liveChatTriggers.triggerid = '';

                if (app === cfg.options.persistent_chat_param) {
                    switch(trigger_id) {
                        case '654c16aa25c75d0007e24a4f':
                            trigger_id = '654c138b4f1ccb0007ff7d85';
                            break;
                        case '654c16cb77779e0007d9eca1':
                            trigger_id = '654c13c577779e0007d9eb8f';
                            break;
                        case '654c16e825c75d0007e24a57':
                            trigger_id = '654c13f8134a040007d7cef7';
                            break;
                        case '654c170d77779e0007d9ecac':
                            trigger_id = '654c142b77779e0007d9ebb0';
                            break;
                        case '654c172b77779e0007d9ecb5':
                            trigger_id = '654c14584f1ccb0007ff7de6';
                            break;
                        case '654c17454f1ccb0007ff7eeb':
                            trigger_id = '654c14874f1ccb0007ff7e02';
                            break;
                      }
                    window.open(`${cfg.options.persistent_chat}${trigger_id}`); 
                } else {

                    // Get all activated trigger objects
                    const triggers = Dimelo.Messaging.Manager.ChatQLoader.manager.triggers;

                    // Find the good one
                    const target_trigger = grep(triggers, function(e){
                    return e.id == trigger_id; });

                    if (!isPushed){
                        handleChatEvent(store, trigger_id);
                    }

                    if (target_trigger.length > 0){
                        Dimelo.Messaging.Manager.ChatQLoader.manager.activateTrigger(target_trigger[0]);
                    }
                }
            }

        });

    }
    
    // Open the live chat
    app.on('liveChat.start', () => {
        startChat();
    });

});